export default "__VITE_ASSET__DLELRE5a__"